import { useEffect, useState } from "react";
import { brandName, navLinks } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      id="top"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "border-b border-background-200 bg-background-50/95 backdrop-blur"
          : "border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between gap-4 px-4 md:h-20 md:px-6">
        <a href="#top" className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50 md:h-10 md:w-10">
            <i className="ri-fire-line text-lg md:text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950 md:text-xl">
              {brandName}
            </span>
            <span className="mt-1 font-label text-[10px] tracking-[0.28em] text-foreground-500">
              热点 · 讨论 · 观点
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="rounded-md px-3 py-2 font-label text-sm text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            订阅热点速递
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((open) => !open)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"} />
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="border-b border-background-200 py-3 font-label text-sm text-foreground-800"
              >
                {link.label}
              </a>
            ))}
          </div>
          <a
            href="#subscribe"
            onClick={() => setMenuOpen(false)}
            className="mt-4 block whitespace-nowrap rounded-md bg-primary-500 py-3 text-center font-label text-sm font-medium text-background-50"
          >
            订阅热点速递
          </a>
        </div>
      ) : null}
    </header>
  );
}